"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseEventCode = void 0;
var CloseEventCode;
(function (CloseEventCode) {
    CloseEventCode[CloseEventCode["NormalClosure"] = 1000] = "NormalClosure";
    CloseEventCode[CloseEventCode["GoingAway"] = 1001] = "GoingAway";
    CloseEventCode[CloseEventCode["ProtocolError"] = 1002] = "ProtocolError";
    CloseEventCode[CloseEventCode["UnsupportedData"] = 1003] = "UnsupportedData";
    CloseEventCode[CloseEventCode["NoStatusReceived"] = 1005] = "NoStatusReceived";
    CloseEventCode[CloseEventCode["AbnormalClosure"] = 1006] = "AbnormalClosure";
    CloseEventCode[CloseEventCode["InvalidFramePayloadData"] = 1007] = "InvalidFramePayloadData";
    CloseEventCode[CloseEventCode["PolicyViolation"] = 1008] = "PolicyViolation";
    CloseEventCode[CloseEventCode["MessageTooBig"] = 1009] = "MessageTooBig";
    CloseEventCode[CloseEventCode["MandatoryExpected"] = 1010] = "MandatoryExpected";
    CloseEventCode[CloseEventCode["InternalError"] = 1011] = "InternalError";
    CloseEventCode[CloseEventCode["ServiceRestart"] = 1012] = "ServiceRestart";
    CloseEventCode[CloseEventCode["TryAgainLater"] = 1013] = "TryAgainLater";
    CloseEventCode[CloseEventCode["BadGateway"] = 1014] = "BadGateway";
    CloseEventCode[CloseEventCode["TLSHandshake"] = 1015] = "TLSHandshake";
    CloseEventCode[CloseEventCode["BadRequest"] = 4000] = "BadRequest";
    CloseEventCode[CloseEventCode["Unauthorized"] = 4001] = "Unauthorized";
    CloseEventCode[CloseEventCode["InternalServerError"] = 4002] = "InternalServerError";
})(CloseEventCode || (exports.CloseEventCode = CloseEventCode = {}));
